import {
  collection,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../providers/AuthProvider";

export const useJobDescriptions = (timesheetId, dbRef) => {
  const [jobDescs, setJobDescs] = useState([]);
  const { userData } = useContext(AuthContext);

  useEffect(() => {
    // On a cold page load (direct URL / hard refresh), this can mount before AuthContext's
    // userData has streamed in from Firestore, leaving associatedAccounts at its default [] -
    // Firestore throws synchronously on an empty 'in' filter, which crashes the whole tree
    // since nothing here catches it. Wait for the real value, same as every provider keyed
    // on userData.associatedAccounts already does.
    if (!userData.uid) {
      return;
    }

    let primaryJobsheetsRef = collection(dbRef, timesheetId, "jobDescriptions");
    let q = query(
      primaryJobsheetsRef,
      orderBy("jobDate", "asc"),
      orderBy("created", "asc"),
      where("createdBy", "in", userData.associatedAccounts)
    );

    const unsubscribeFromJobDescs = onSnapshot(q, (doc) => {
      let jdsData = [];

      doc.forEach((jd) => {
        jdsData.push(jd.data());
      });

      setJobDescs(jdsData);
    });

    return () => {
      unsubscribeFromJobDescs();
    };
  }, [dbRef, timesheetId, userData.associatedAccounts, userData.uid]);

  //   useEffect(() => {
  //     timesheetsRef
  //       .doc(timesheetId)
  //       .collection("jobDescriptions")
  //       .get()
  //       .then(querySnap => {
  //         const dbJobDescs = [];

  //         querySnap.forEach(jd => {
  //           dbJobDescs.push(jd.data());
  //         });
  //         setJobDescs(dbJobDescs);
  //       });
  //   }, [timesheetId]);

  return jobDescs;
};
